import React from 'react';
import { columnNames } from './strings';
import { buildColumn, formatFuncs, ColumnNameToFluctuationTypeEnum, hasFluctuations } from './shared';

export function buildFluctuationColumn(options = {}) {
  const {
    name, i18n, format, title, helpId,
  } = options;
  const key = options.key || name;
  const columnTitle = options.title || columnNames[key];
  const localizedTitle = i18n ? i18n.getString(columnTitle) : columnTitle;
  return {
    ...buildColumn({
      ...options, title: localizedTitle, helpId, key,
    }),
    className: `performance-metrics performance-metrics-${options.name}`,
    onRender: (item) => {
      const { PerformanceMetrics, AvailableInsightTypeIds } = item;
      const value = PerformanceMetrics[options.name];

      const metricType = ColumnNameToFluctuationTypeEnum[name];
      const metricName = title;
      const metricValue = format(i18n)(value);
      const hasFluctuation = hasFluctuations({
        propertyName: name,
        availableInsightTypeIds: AvailableInsightTypeIds,
        IsOverall: item.$total && item.$total.type === 'overall',
      });
      return (
        <>
          <span className="performance-metrics-value">{metricValue || '-'}</span>
          <span className="performance-metrics-fluctuation">
            {hasFluctuation && <span
              className="iconba iconba-Insights clickable"
              tabIndex="0"
              role="button"
              data-metric-name={metricName}
              data-metric-value={metricValue}
              data-metric-type={metricType}
            />}
          </span>
        </>
      );
    },
  };
}

export const ColumnClicksWithFluctuation = ({ i18n, helpId }) => buildFluctuationColumn({
  i18n,
  name: 'Clicks',
  format: formatFuncs.integer,
  helpId,
});

export const ColumnImpressionsWithFluctuation = ({ i18n, helpId = 'Page_CampaignGrids_Impr' }) => buildFluctuationColumn({
  i18n,
  name: 'Impressions',
  format: formatFuncs.integer,
  helpId,
});

export const ColumnSpendWithFluctuation = ({ i18n, helpId }) => buildFluctuationColumn({
  i18n,
  name: 'Spend',
  format: formatFuncs.decimal,
  helpId,
});
